// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/ng-tags-input/build/ng-tags-input.bootstrap.min.css
// module id = 29
// module chunks = 0